var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',_vm._b({attrs:{"color":"faded","flat":"","round":"","dense":"","icon":"content_paste","title":_vm.title},on:{"click":_vm.copyToClipboard}},'q-btn',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }